import React, { ReactNode, createContext, useContext, useState } from "react";

const NULL: any = null;

interface TweakMap {
    [id: string]: string;
}

const TweakContext = createContext<{
    tweaks: TweakMap;
    setTweak: (tweakId: string, value: string) => void;
}>(NULL);

export const useTweaks = () => {
    return useContext(TweakContext);
};

export const TweakProvider: React.FC<{
    initialState: TweakMap;
    children: ReactNode;
}> = (props) => {
    const { initialState } = props;

    const [tweaks, setTweaks] = useState<TweakMap>(initialState);

    return (
        <TweakContext.Provider
            value={{
                tweaks,
                setTweak: (id, value) => {
                    setTweaks((prev) => {
                        return {
                            ...prev,
                            [id]: value,
                        };
                    });
                },
            }}
        >
            {props.children}
        </TweakContext.Provider>
    );
};
